import React, { Fragment } from 'react'
import { Helmet } from 'react-helmet';
import logo from '../images/LOGO marketBiz-03.png';
import videoini from '../images/videoplayback.mp4';

function MenuInicio() {
  const containerStyle = {
      display: 'flex',
      justifyContent: 'space-between',
      gap: '10px',
      margin: '5px 0',
      flexWrap: 'wrap', // Allow wrapping
  };
    return (
        <div className="content">
          <Helmet>
            <title>MarketBiz.ai - Inicio</title>
            <meta
              name="description"
              content="MarketBiz.ai: Transformando la accesibilidad y sostenibilidad en licitaciones con inteligencia artificial. Ingresa y descubre nuestras herramientas."
            />
            <meta
              name="keywords"
              content="licitaciones, inteligencia artificial, gestión de documentos, RUP, UNSPSC, licitaciones públicas, MarketBiz"
            />
            <meta
              property="og:title"
              content="MarketBiz.ai - Transformando Licitaciones con AI"
            />
            <meta
              property="og:description"
              content="Descubre cómo MarketBiz.ai optimiza la gestión de documentos de licitación mediante inteligencia artificial. ¡Únete ahora!"
            />
            <meta property="og:image" content={logo} />
            <meta property="og:url" content="https://www.marketbiz.ai" />
            <link rel="canonical" href="https://www.marketbiz.ai" />
          </Helmet>
          <img src={logo} alt="Logo marketBiz" className='responsive-image'/>

          <h2 className="subtitulo">Transformando la accesibildiad y sostenibilidad en licitaciones con AI.</h2>
          <p>La primera App AI diseñada para ayudar a todas la empresas del país a mejorar su participación en licitaciones gubernamentales en Colombia y en el exterior, fomentando el desarrollo ambiental sostenible.</p>
          <button className="large-button" onClick={() => window.location.href = 'https://app.marketbiz.ai/'}>INGRESA</button>
          <p></p>
          <div className="video-container">
            <video 
              className="responsive-video" 
              autoPlay 
              loop 
              muted 
              playsInline
              controls
            >
              <source src={videoini} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            
          </div>
            <div className="resultados-container" style={containerStyle}>
              <h3 className="resultados-title">RESULTADOS </h3>
              <div className="resultados-item">
                <p className="resultados-item-value">70%+</p>
                <p className="resultados-item-description">Participación PYMES</p>
              </div>
              <div className="resultados-item">
                <p className="resultados-item-value">320 millones de pesos</p>
                <p className="resultados-item-description">Ahorro en costo de impresión</p>
              </div>
              <div className="resultados-item" style={{ width: '30%' }}>
                <p className="resultados-item-value">60,000</p>
                <p className="resultados-item-description">Árboles no talados, fomentando ahorro de papel al año.</p>
              </div>
            </div>
        </div>
    );
}

export default MenuInicio;